import { Injectable } from '@angular/core';
export function isNullOrUndefined(value : any){
  return value === null || value === undefined;
}

export function isNumber(value : any)
{
  return typeof value === 'number';
}

@Injectable()
export class CorrectYeKeService {
  public static getCorrectYeKe(text: string): string {
    if (!text)
      return '';
    if (isNumber(text))
      return text;
    var s = text.replace(String.fromCharCode(1603), String.fromCharCode(1705))
      .replace(String.fromCharCode(1609), String.fromCharCode(1740))
      .replace(String.fromCharCode(1610), String.fromCharCode(1740))
      .replace(String.fromCharCode(1568), String.fromCharCode(1740))
      .replace(String.fromCharCode(1574), String.fromCharCode(1740))
      .replace(String.fromCharCode(1597), String.fromCharCode(1740))
      .replace(String.fromCharCode(1598), String.fromCharCode(1740))
      .replace(String.fromCharCode(1599), String.fromCharCode(1740))
      .replace(String.fromCharCode(1656), String.fromCharCode(1740))
      .replace(String.fromCharCode(1744), String.fromCharCode(1740))
      .replace(String.fromCharCode(1745), String.fromCharCode(1740))
      .replace(String.fromCharCode(1741), String.fromCharCode(1740))
      .replace(String.fromCharCode(1742), String.fromCharCode(1740));
    if (isNullOrUndefined(s))
      return text;
    return s;
  }
}
